import styled from "styled-components";
import { TextFont, Colors } from "../../config";
import {
  FareSummaryWrapper,
  FareSummaryHeader,
} from "../FareSummary/FareSummaryContainer";
import FlightTicketDownload from "./FlightTicketDownload";

const noTicket = require("../../assets/images/NoTickets.png");

const TravelQuotation = ({
  flightTicket,
  employeeTicketCount,
  guestTicketCount,
  label=''
}) => {
  const emptyCondition = flightTicket?.length > 0;
  return (
    <FareSummaryWrapper>
      <FareSummaryHeader>
        <HeaderWrapper>
          <TextFont
            fontColor={Colors.sharkApprox}
            fontSize="1.125rem"
            fontWeight="700"
          >
            {label} Quotation
          </TextFont>
        </HeaderWrapper>
      </FareSummaryHeader>
      <FlightTicketBody>
        {emptyCondition ? (
          <FlightTicketDownload
            type={`${label} Quote`}
            flightTicket={flightTicket}
            employeeTicketCount={employeeTicketCount}
            guestTicketCount={guestTicketCount}
          />
        ) : (
          <NoTicketWrapper>
            <img src={noTicket} alt="No Tickets" />
            <TextFont fontColor={Colors.bombay} fontSize="1rem">
              No Quotation
            </TextFont>
          </NoTicketWrapper>
        )}
      </FlightTicketBody>
    </FareSummaryWrapper>
  );
};

const FlightTicketBody = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 0 0 0.5rem 0.5rem;
  background: ${Colors.white};
  padding: 1rem 0.5rem 0.875rem 1.375rem;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: ${Colors.brandOne};
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const NoTicketWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  gap: 1.125rem;
`;

export default TravelQuotation;
